import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import { EExternalRoutes } from "@core-types/routes.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Text } from "@mantine/core";
import { Link } from "react-router";
import type { breakpoints } from "src/App";

interface Props {
  iconVisibleFrom?: breakpoints;
  textVisibleFrom?: breakpoints;
}

const Discord: React.FC<Props> = ({
  iconVisibleFrom: iconHiddenFrom,
  textVisibleFrom: textHiddenFrom,
}) => {
  const { t } = useAppTranslation("common.discord");

  return (
    <Button
      className="no-spacing"
      color="secondary.5"
      component={Link}
      leftSection={
        <AppThemeIcon className="pt-1 text-secondary-600">
          <Icon.Thunder alt={t("alt")} size={20} title={t("title")} />
        </AppThemeIcon>
      }
      rel="noreferrer noopener"
      size="compact-md"
      target="_blank"
      to={EExternalRoutes.DISCORD}
      variant="transparent"
      visibleFrom={iconHiddenFrom}
      w={"fit-content"}
    >
      <Text
        className="font-inter font-semibold text-gradient-blue-purple xl:inline"
        pt={3}
        visibleFrom={textHiddenFrom}
      >
        Discord
      </Text>
    </Button>
  );
};

export default Discord;
